import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const languages = [
  { code: 'zh', name: '繁體中文' },
  { code: 'zh_CN', name: '简体中文' },
  { code: 'en', name: 'English' },
  { code: 'jp', name: '日本語' },
  { code: 'ko', name: '한국어' }
]

export default function LanguagePage() {
  const { t, i18n } = useTranslation('settings')
  const [currentLanguage, setCurrentLanguage] = useState('zh')
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    setCurrentLanguage(i18n.language || 'zh')
  }, [i18n.language])

  const handleLanguageChange = (langCode: string) => {
    setCurrentLanguage(langCode)
    i18n.changeLanguage(langCode)
    localStorage.setItem('language', langCode)
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">{t('language.title')}</h1>
        <p className="text-gray-600 mt-2">{t('language.description')}</p>
      </div>

      {/* Language Options */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('language.selectLanguage')}</h2>

        <div className="space-y-3">
          {languages.map((language) => (
            <div
              key={language.code}
              className={`flex items-center justify-between p-4 rounded-lg border transition-all cursor-pointer ${
                currentLanguage === language.code
                  ? 'border-primary bg-primary/5 shadow-md'
                  : 'border-gray-200 hover:border-primary hover:bg-gray-50'
              }`}
              onClick={() => handleLanguageChange(language.code)}
            >
              <div className="flex items-center space-x-3">
                <div>
                  <div className="font-medium text-gray-900">{language.name}</div>
                  <div className="text-sm text-gray-500">{language.code.toUpperCase()}</div>
                </div>
              </div>

              {isClient && currentLanguage === language.code && (
                <div className="flex items-center text-primary">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="ml-2 text-sm font-medium">{t('language.selected')}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Additional Info */}
      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex">
          <svg className="w-5 h-5 text-blue-400 mr-3 mt-0.5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <div>
            <h3 className="text-sm font-medium text-blue-800">{t('language.note.title')}</h3>
            <p className="text-sm text-blue-700 mt-1">{t('language.note.description')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

